import { CalculatorOutlined } from '@ant-design/icons';
import { RichiestaDTO, RichiestaModuloDTO } from '@framework/api-client';
import { StyledHtmlText } from '@framework/engine';
import { SubmissionBurdenLogic } from '@framework/frontoffice-submission';
import { useTranslation } from '@framework/i18n';
import { FlexRow, ResponsiveCard } from '@framework/ui';
import { Row, Typography } from 'antd';
import DOMPurify from 'dompurify';
import { useMemo } from 'react';
import styled from 'styled-components';
import { PaymentStateTag } from './PaymentStateTag';
import {
  ElementSummaryWrapper,
  ElementTitle,
} from './summary-items/SubmissionSummary.styles';
import { SubmissionModuleSummary } from './summary-items/SubmissionSummaryModule';
const Title = Typography.Title;

const SummaryCard = styled(ResponsiveCard)`
  border: 1px solid ${props => props.theme.colorSplit};
  font-size: 18px;
`;

const PaymentStatusWrapper = styled.div`
  margin-bottom: 0;
  font-size: 1.1rem;
  font-weight: 500;
`;
const SubmissionSummaryTitle = styled(Title)`
  &&& {
    font-size: ${props => props.theme.fontSizeHeading3}px;
    line-height: ${props => props.theme.lineHeightHeading3};
  }
`;

interface Props {
  text?: string | null;
  submission?: RichiestaDTO;
  modules?: RichiestaModuloDTO[];
  /** Se c'è più di un modulo, mostriamo il tasto di download per ogni modulo */
  hasInlineDownload?: boolean;
}

export function SubmissionSummary({
  text,
  submission,
  modules,
  hasInlineDownload,
}: Props) {
  const { statoOneri } = useMemo(() => submission ?? {}, [submission]);
  const showPaymentStatus = SubmissionBurdenLogic.hasBurdens(statoOneri);
  const { t } = useTranslation();

  return (
    <SummaryCard>
      <SubmissionSummaryTitle level={2}>
        {t(
          'submission-summary.riepilogo-richiesta',
          'Riepilogo della Richiesta',
        )}
      </SubmissionSummaryTitle>
      {text && (
        <Typography.Paragraph>
          <StyledHtmlText
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(text),
            }}
          />
        </Typography.Paragraph>
      )}
      <Row>
        {modules &&
          modules.length > 0 &&
          modules.map(module => (
            <SubmissionModuleSummary
              key={module.id}
              module={module}
              submissionId={submission?.id}
              hasInlineDownload={hasInlineDownload}
            />
          ))}
        {showPaymentStatus && (
          <ElementSummaryWrapper>
            <FlexRow
              style={{ width: '100%' }}
              gutter={12}
              left={
                <ElementTitle>
                  <CalculatorOutlined aria-hidden />{' '}
                  {t('submission-summary.stato-oneri', 'Stato Pagamenti')}
                </ElementTitle>
              }
              right={
                <PaymentStatusWrapper>
                  <PaymentStateTag state={statoOneri} />
                </PaymentStatusWrapper>
              }
            />
          </ElementSummaryWrapper>
        )}
      </Row>
    </SummaryCard>
  );
}
